import React, { useContext, useState } from "react"
import { Link, useMediaQuery } from "@material-ui/core";
import { getLocationFromStorage } from "../../utils/localStorageHelper";
import { useHistory, useLocation } from "react-router-dom";
import { LocationForBreadcrumb } from "../../types/location-breadcrumbs";
import Box from '@material-ui/core/Box'
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import IconButton from '@material-ui/core/IconButton'

import { MdHome } from "react-icons/md";
import { IoMdSearch } from "react-icons/io";
import { useStyles } from "./styles";
import colorContext from "../../Context/colorContext";

interface BreadcrumbProps {
  slug: string;
  newLink?: {
    url: string;
    title: string;
  }
}

type LinkEnumProps = {
  [key: string]: {
    url: string | null;
    onClick: VoidFunction | null
  }
}

const LOCATIONS_TO_EXCLUDE = ['Categorias', 'Serviços em destaque']

export default function Breadcrumb({ slug, newLink }: BreadcrumbProps) {
  const configColors = useContext(colorContext);
  const { state, pathname } = useLocation<LocationForBreadcrumb>()
  const classes = useStyles(configColors);
  const history = useHistory();
  const [textSearch, setTextSearch] = useState<string>('');
  const matches = useMediaQuery('(min-width:935px)');
  const currentBreadcrumbTitle = state?.state?.breadcrumbTitle || getLocationFromStorage('@current-breadcrumb-title')?.['breadcrumbTitle'];
  const isValidLocationsPath = pathname?.toLowerCase()?.includes('agendamentos') ||
    pathname?.toLowerCase()?.includes('orgao') ||
    pathname?.toLowerCase().includes('buscar/q=') ||
    pathname?.toLowerCase().includes('mapa-do-site');

  const LINKS: LinkEnumProps = {
    'Lista de Órgãos': {
      url: '/orgaos',
      onClick: null,
    },
    'Agendamento': {
      url: '/agendamentos',
      onClick: null,
    },
    'Resultados da busca': {
      url: null,
      onClick: () => history.goBack()
    }
  }

  const submitSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (textSearch) {
      history.push(`/buscar/q=${encodeURIComponent(textSearch)}`);
      setTextSearch('');
    }
  };

  const renderPrimaryAnchor = () => {
    if (!currentBreadcrumbTitle) return null

    if (!LOCATIONS_TO_EXCLUDE.includes(currentBreadcrumbTitle) && !isValidLocationsPath) {
      const linkConfig = LINKS[currentBreadcrumbTitle];

      const href = linkConfig?.url || undefined;

      return (
        <Link
          onClick={linkConfig?.onClick || undefined}
          href={href}
          style={{
            textDecoration: 'none',
            cursor: linkConfig?.onClick ? 'pointer' : 'default'
          }}>
          <Typography className={classes.itemBreadcrumb}>
            {currentBreadcrumbTitle}
          </Typography>
        </Link>
      )
    }
  }

  return (
    <Box className={classes.main}>
      <Box
        display='flex'
        maxWidth='1040px'
        alignItems='center'
        width='100%'
        flexWrap='wrap'
        justifyContent={matches ? 'space-between' : 'flex-end'}
      >
        <Breadcrumbs
          separator='/'
          className={classes.breadcrumbs}
          classes={{ li: classes.breadcrumbLi }}
        >
          <MdHome
            className={classes.icon}
            onClick={(e: React.SyntheticEvent) => {
              e.preventDefault();
              history.push('/');
            }}
          />
          {renderPrimaryAnchor()}
          {newLink && (
            <Link
              href={newLink.url}
              style={{ textDecoration: 'none' }}
              onClick={(e: React.SyntheticEvent) => {
                e.preventDefault();
                history.push(newLink.url);
              }}
            >
              <Typography className={classes.itemBreadcrumb}>
                {newLink.title}
              </Typography>
            </Link>
          )}
          <Typography className={classes.itemBreadcrumb}>{slug}</Typography>
        </Breadcrumbs>
        <form
          onSubmit={submitSearch}
          style={{
            display: 'flex',
            justifyContent: `${matches ? 'flex-end' : 'center'}`,
            flexGrow: 1,
            minWidth: 300,
            margin: '15px 16px',
          }}
        >
          <input
            value={textSearch}
            onChange={(e): void => setTextSearch(e.target.value)}
            className={classes.inputSearch}
            style={{
              width: '100%',
              borderRadius: '4px 0px 0px 4px',
            }}
            placeholder='Digite aqui o que procura...'
          />
          <IconButton
            type='submit'
            className={classes.buttonSearch}
            style={{
              borderRadius: '0px 4px 4px 0px',
            }}
          >
            <IoMdSearch className={classes.iconSearch} />
          </IconButton>
        </form>
      </Box>
    </Box>
  )
}